import { getAxonUserData, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonPageView() {
  function reportPageView() {
    pushAxonEvent('page_view', {
      user_data: getAxonUserData(),
    })
  }

  return { reportPageView }
}
